import httpClient from "./httpClient";

export async function buscarReguaChurn() {
  const response = await httpClient.get("/api/configuracoes/churn-regua");
  return response.data || {};
}

export async function atualizarReguaChurn(limites = {}) {
  const response = await httpClient.put("/api/configuracoes/churn-regua", limites);
  return response.data || {};
}

